import { defineAsyncComponent } from 'vue'
export default {
  background: defineAsyncComponent(() => import("/home/runner/work/guardiann-homepage/guardiann-homepage/layouts/background.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/work/guardiann-homepage/guardiann-homepage/layouts/default.vue").then(m => m.default || m))
}